module.exports = __webpack_public_path__ + "static/media/bg-1-art.960ad8cc.png";